var EVISEN = EVISEN || {};
EVISEN.EC = {};

EVISEN.EC.SLIDER = function ($wrapper) {
  this.$wrapper = $wrapper;
  this.init();
};

EVISEN.EC.SLIDER.prototype = {
  init: function () {
    new Swiper(this.$wrapper, {
      slidesPerView: 'auto',
      loop: true,
      // breakpoints: {
      //   990: {
      //     centeredSlides: true,
      //   }
      // },
      pagination: {
        el: '.c-slider-pagination',
        clickable: true,
      }
    });
  }
};

EVISEN.EC.SMOOTHSCROLL = function () {
  this.$links = document.querySelectorAll('a');
  this.$targets = document.querySelectorAll('.jsc-smoothscroll__target');
  this.init();
};

EVISEN.EC.SMOOTHSCROLL.prototype = {
  init: function () {
    this.bindEvent();
  },

  bindEvent: function () {
    const $triggers = [...this.$links].filter(($link) => $link.getAttribute('href').startsWith('#'));

    if (!$triggers) return;

    $triggers.forEach(($trigger) => {
      $trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.getTargetTop($trigger);
      });
    });
  },

  getTargetTop: function ($trigger) {
    const triggerFlg = $trigger.getAttribute('href').slice(1);

    this.$targets.forEach(($target) => {
      const targetFlg = $target.getAttribute('id');

      if (triggerFlg === targetFlg) {
        const scrollTop = window.pageYOffset;
        const targetTop = $target.getBoundingClientRect().top + scrollTop;

        this.scrollTo(targetTop);
      }
    });
  },

  scrollTo: function (targetTop) {
    window.scrollTo({
      top: targetTop,
      behavior: 'smooth'
    });
  }
};

new EVISEN.EC.SLIDER(document.querySelector('.jsc-slider'));
new EVISEN.EC.SMOOTHSCROLL();